import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=41f12dee&scoped=true&"
import script from "./alipay.vue?vue&type=script&lang=js&"
export * from "./alipay.vue?vue&type=script&lang=js&"
import style0 from "./alipay.vue?vue&type=style&index=0&id=41f12dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f12dee",
  null
  
)

export default component.exports